import { Music } from "lucide-react";

export default function TikTokIcon() {
  return (
    <div
      className="w-10 h-10 rounded-full flex items-center justify-center 
                 bg-black relative overflow-hidden"
    >
      {/* Nota musical */}
      <Music className="w-5 h-5 text-white" />

      {/* Detalles estilo TikTok (sombra turquesa y fucsia) */}
      <div className="absolute inset-0 rounded-full 
                      ring-2 ring-offset-2 ring-offset-black 
                      ring-cyan-400 mix-blend-screen" />
      <div className="absolute inset-0 rounded-full 
                      ring-2 ring-offset-2 ring-offset-black 
                      ring-pink-500 mix-blend-screen translate-x-1 translate-y-1" />
    </div>
  );
}
